import WellContacts from './WellContacts';

export default WellContacts;



// WEBPACK FOOTER //
// ./src/Components/Main/WellWorkflow/WellContacts/index.tsx